/**
 * @generated SignedSource<<6a7f004060b931442badaff139629ac2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateStudyInput = {
  allowAutoApproval?: boolean | null;
  availabilityBuffer?: string | null;
  availabilitySlots?: ReadonlyArray<AvailabilitySlotInput | null> | null;
  claimLink?: string | null;
  clientMutationId?: string | null;
  defaultIncentive?: string | null;
  defaultIncentivePoints?: number | null;
  duration?: string | null;
  incentiveType?: string | null;
  inviteMeetingName?: string | null;
  inviteMeetingType?: string | null;
  inviteMessage?: string | null;
  inviteMessageCustomized?: boolean | null;
  languageCode?: string | null;
  launchPanelEmailSend?: boolean | null;
  meetingLink?: string | null;
  name?: string | null;
  namePublic?: string | null;
  panelFilters?: any | null;
  privacyPolicy?: string | null;
  rewardDescription?: string | null;
  scheduled?: any | null;
  scheduledBy?: string | null;
  schedulingLink?: string | null;
  schedulingType?: string | null;
  studyId: string;
  studySessions?: ReadonlyArray<StudySessionInput | null> | null;
  tags?: ReadonlyArray<TagCreateOrAttachInput> | null;
  type?: string | null;
  usesApiToMarkComplete?: boolean | null;
  voxpopmeProjectId?: number | null;
  voxpopmeRecorderEnabled?: boolean | null;
};
export type AvailabilitySlotInput = {
  availabilityBuffer?: number | null;
  duration?: number | null;
  end?: any | null;
  id?: string | null;
  inPerson?: boolean | null;
  interviewer?: string | null;
  meetingDetails?: string | null;
  meetingLink?: string | null;
  meetingLocation?: string | null;
  placesLimit?: number | null;
  start?: any | null;
};
export type StudySessionInput = {
  availabilitySlots?: ReadonlyArray<AvailabilitySlotInput | null> | null;
  duration?: number | null;
  id?: string | null;
  name?: string | null;
};
export type TagCreateOrAttachInput = {
  color?: string | null;
  id?: string | null;
  name?: string | null;
};
export type SlotsPage_UpdateStudy_Mutation$variables = {
  input: UpdateStudyInput;
};
export type SlotsPage_UpdateStudy_Mutation$data = {
  readonly updateStudy: {
    readonly study: {
      readonly availabilitySlots: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly duration: number | null;
            readonly id: string;
          } | null;
        } | null>;
      };
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"SlotsPage_study">;
    } | null;
  } | null;
};
export type SlotsPage_UpdateStudy_Mutation = {
  response: SlotsPage_UpdateStudy_Mutation$data;
  variables: SlotsPage_UpdateStudy_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "end",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availabilityBuffer",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "InterviewerNode",
  "kind": "LinkedField",
  "name": "interviewer",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "inPerson",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingLink",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingLocation",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingDetails",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "placesLimit",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countOfBookedSlots",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventsType",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SlotsPage_UpdateStudy_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateStudyPayload",
        "kind": "LinkedField",
        "name": "updateStudy",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StudyAvailabilitySlotConnection",
                "kind": "LinkedField",
                "name": "availabilitySlots",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StudyAvailabilitySlotEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StudyAvailabilitySlotNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SlotsPage_study"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SlotsPage_UpdateStudy_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateStudyPayload",
        "kind": "LinkedField",
        "name": "updateStudy",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StudyAvailabilitySlotConnection",
                "kind": "LinkedField",
                "name": "availabilitySlots",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StudyAvailabilitySlotEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StudyAvailabilitySlotNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TenantNode",
                "kind": "LinkedField",
                "name": "tenant",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableCalendlyIntegration",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vpmAccountId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "schedulingType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "schedulingLink",
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "approvedCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "voxpopmeRecorderEnabled",
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canHaveMultipleSessions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StudySessionNodeConnection",
                "kind": "LinkedField",
                "name": "sessions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StudySessionNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StudySessionNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v15/*: any*/),
                          (v3/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StudyAvailabilitySlotNodeConnection",
                            "kind": "LinkedField",
                            "name": "availabilitySlots",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StudyAvailabilitySlotNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StudyAvailabilitySlotNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v4/*: any*/),
                                      (v5/*: any*/),
                                      (v6/*: any*/),
                                      (v3/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v7/*: any*/),
                                      (v13/*: any*/),
                                      {
                                        "alias": "_value",
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "meetingDetails",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StudySessionNode",
                                        "kind": "LinkedField",
                                        "name": "session",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "StudyNode",
                                            "kind": "LinkedField",
                                            "name": "study",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              (v14/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "StudySessionNodeConnection",
                                                "kind": "LinkedField",
                                                "name": "sessions",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "StudySessionNodeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "StudySessionNode",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v2/*: any*/),
                                                          (v15/*: any*/),
                                                          (v3/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "StudyAvailabilitySlotNodeConnection",
                                                            "kind": "LinkedField",
                                                            "name": "availabilitySlots",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "StudyAvailabilitySlotNodeEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "StudyAvailabilitySlotNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v2/*: any*/),
                                                                      (v4/*: any*/),
                                                                      (v5/*: any*/),
                                                                      (v3/*: any*/),
                                                                      (v7/*: any*/),
                                                                      (v8/*: any*/),
                                                                      (v11/*: any*/),
                                                                      (v9/*: any*/),
                                                                      (v10/*: any*/),
                                                                      (v12/*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v2/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0afc1d69c0e40af0c026b2fbb857ac1b",
    "id": null,
    "metadata": {},
    "name": "SlotsPage_UpdateStudy_Mutation",
    "operationKind": "mutation",
    "text": "mutation SlotsPage_UpdateStudy_Mutation(\n  $input: UpdateStudyInput!\n) {\n  updateStudy(input: $input) {\n    study {\n      id\n      availabilitySlots {\n        edges {\n          node {\n            id\n            duration\n          }\n        }\n      }\n      ...SlotsPage_study\n    }\n  }\n}\n\nfragment InputSlotDetails_slot on StudyAvailabilitySlotNode {\n  id\n  _value: meetingDetails\n  session {\n    study {\n      id\n      eventsType\n      sessions {\n        edges {\n          node {\n            id\n            name\n            duration\n            availabilitySlots {\n              edges {\n                node {\n                  id\n                  start\n                  end\n                  duration\n                  interviewer {\n                    email\n                    id\n                  }\n                  inPerson\n                  meetingDetails\n                  meetingLink\n                  meetingLocation\n                  placesLimit\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment SessionsForm_FocusGroupSlotEditor_slot on StudyAvailabilitySlotNode {\n  countOfBookedSlots\n  ...InputSlotDetails_slot\n}\n\nfragment SessionsForm_InterviewSlotEditor_slot on StudyAvailabilitySlotNode {\n  countOfBookedSlots\n  ...InputSlotDetails_slot\n}\n\nfragment SessionsForm_study on StudyNode {\n  id\n  dId\n  type\n  eventsType\n  status\n  approvedCount\n  tenant {\n    vpmAccountId\n    id\n  }\n  canHaveMultipleSessions\n  sessions {\n    edges {\n      node {\n        id\n        name\n        duration\n        countOfBookedSlots\n        availabilitySlots {\n          edges {\n            node {\n              id\n              start\n              end\n              availabilityBuffer\n              duration\n              inPerson\n              meetingLink\n              meetingLocation\n              meetingDetails\n              placesLimit\n              interviewer {\n                email\n                id\n              }\n              ...SessionsForm_FocusGroupSlotEditor_slot\n              ...SessionsForm_InterviewSlotEditor_slot\n            }\n          }\n        }\n      }\n    }\n  }\n  voxpopmeRecorderEnabled\n}\n\nfragment SlotsPage_study on StudyNode {\n  id\n  dId\n  type\n  status\n  availabilitySlots {\n    edges {\n      node {\n        id\n        start\n        end\n        duration\n        availabilityBuffer\n        interviewer {\n          email\n          id\n        }\n        inPerson\n        meetingLink\n        meetingLocation\n        meetingDetails\n        placesLimit\n        countOfBookedSlots\n      }\n    }\n  }\n  tenant {\n    enableCalendlyIntegration\n    id\n  }\n  availabilityBuffer\n  schedulingType\n  schedulingLink\n  meetingLink\n  approvedCount\n  voxpopmeRecorderEnabled\n  ...SessionsForm_study\n}\n"
  }
};
})();

(node as any).hash = "fd898ea99ed938955e4bcc1431cd781d";

export default node;
